@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (AccessAllowed && pageReady) {
  <div class="p-3 flex flex-column flex-auto">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Link
      </h3></div>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <!-- Only a link that has already been saved has one of these, so a new link shows
          nothing here until it has been saved and reopened. -->
          @if (savedLink) {
            <div class="field mb-4 col-12">
              <label for="savedlink" class="font-medium">Saved Link</label>
              <div style="display:flex; gap:8px; align-items:center; flex-wrap:wrap;">
                <input id="savedlink" type="text" pInputText [value]="savedLink" readonly
                  style="flex:1 1 320px; min-width:0; background-color:#f8f7fb;"
                  (focus)="$event.target.select()">
                  <button pButton pRipple type="button" class="p-button p-element p-button-warn w-auto" style="flex:0 0 auto;" (click)="copyLink()">
                    <span class="pi pi-copy" style="margin-right:8px;"></span>
                    Copy Link
                  </button>
                </div>
              </div>
            }
            <div class="field mb-4 col-12">
              <label for="linkame" class="font-medium">Link Name</label>
              <input [(ngModel)]="Link.linkname" id="linkname" type="text" [ngStyle]="{'border-color': (LinkNameValid==false) ? '#FF0000':''}" pInputText>
            </div>
            @if (!LinkNameValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Link name.</div>
            }
            <div class="field mb-4 col-12">
              <label for="pckorgroup" class="font-medium">Link Type</label>
              <p-selectbutton id="pckorgroup" [style]="{'width': '100%'}" [options]="stateOptionsType" [(ngModel)]="Link.linktype" ></p-selectbutton>
            </div>
            @if (Link.linktype =='PACKAGE') {
              <div class="field mb-4 col-12">
                <label for="ddlPackage" class="font-medium">Select a Package</label><br>
                <p-select [options]="packages" [(ngModel)]="selectedpackage" placeholder="Select a Package" [showClear]="true" optionLabel="name"></p-select>
                @if (!LinkPackageValid) {
                  <div class="text-danger" Style="margin-left:10px"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a Package.</div>
                }
              </div>
            }
            @if (Link.linktype =='PACKAGEGROUP') {
              <div class="field mb-4 col-12">
                <label for="ddlPackageGroup" class="font-medium">Select a Package Group</label><br>
                <p-select [options]="packagegroups" [(ngModel)]="selectedpackagegroup" placeholder="Select a Package Group" [showClear]="true" optionLabel="packagegroupname"></p-select>
                @if (!LinkPackageGroupValid) {
                  <div class="text-danger" Style="margin-left:10px"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a Package Group.</div>
                }
              </div>
            }
            @if (Link.linktype =='VOUCHER') {
              <div class="field mb-4 col-12">
                <label for="ddlPackageGroup" class="font-medium">Enter a Gift Voucher value</label><br>
                <p-inputnumber [(ngModel)]="Link.vouchervalue" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0.01" [max]="99999.99"></p-inputnumber>
                @if (!LinkVoucherValid) {
                  <div class="text-danger" Style="margin-left:10px"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Gift Voucher value.</div>
                }
              </div>
            }
            @if (Link.linktype =='MEMBERSHIP') {
              <div class="field mb-4 col-12">
                <label for="ddlPackageGroup" class="font-medium">Select a Membership</label><br>
                <p-select [options]="memberships" [(ngModel)]="selectedmembership" placeholder="Select a Membership" [showClear]="true" optionLabel="name"></p-select>
                @if (!LinkMembershipValid) {
                  <div class="text-danger" Style="margin-left:10px"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a Membership.</div>
                }
              </div>
            }
            @if (Link.linktype == 'PACKAGE') {
              <div class="field mb-4 col-12">
                <div class="field mb-4 col-12">
                  <label for="pckorgroup" class="font-medium">Would you like select a Date for this link?</label>
                  <p-selectbutton id="pckorgroup" [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="LinkDate" (onChange)="DoDateValidCheck()" ></p-selectbutton>
                </div>
                @if (LinkDate) {
                  <div class="field mb-4 col-12" style="max-width: 500px;">
                    <label for="venueclosingstartdate">What Date would you like this link to be for?</label>
                    <p-datepicker [selectOtherMonths]="true" [(ngModel)]="DateToBook" firstDayOfWeek="1" dateFormat="dd/mm/yy" (onSelect)="DoDateValidCheck(); DoDateCheck();" [showIcon]="true" inputId="venueclosingstartdate"></p-datepicker>
                    <div style="clear:both;"></div>
                    @if (!LinkDateValid) {
                      <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>The selected Date must be in the future and can't be earlier than the Package Start Date ({{MinDate | date:'dd/MM/yyyy'}}) or later than the Package End Date ({{MaxDate | date:'dd/MM/yyyy'}})</div>
                    }
                  </div>
                }
              </div>
            }
            @if (Link.linktype == 'PACKAGE') {
              <div style="width:100%;">
                <div class="field mb-4 col-12">
                  <label for="pckorgroup" class="font-medium">Would you like select a Time for this link?</label>
                  <p-selectbutton id="pckorgroup" [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="LinkTime" ></p-selectbutton>
                </div>
                @if (LinkTime) {
                  <div class="field mb-4 col-12" style="max-width: 500px;">
                    <label for="venueclosingenddate">What Time would you like this link to be for?</label>
                    <br>
                      <p-select [options]="linkTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="linkStartTimeHours" optionValue="code" optionLabel="name"></p-select>
                      <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                      <p-select [options]="linkTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="linkStartTimeMinutes" optionValue="code" optionLabel="name"></p-select>
                    </div>
                  }
                </div>
              }
              <div class="field mb-4 col-12">
                <label for="pckorgroup" class="font-medium">Would you like this link to expire?</label>
                <p-selectbutton id="pckorgroup" [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="LinkExpire" (click)="doLinkExpiry(this)"></p-selectbutton>
              </div>
              @if (LinkExpire) {
                <div class="field mb-4 col-12" style="max-width: 500px;">
                  <label for="venueclosingstartdate">What date would you like the link to expire?</label>
                  <p-datepicker [selectOtherMonths]="true" [(ngModel)]="Link.expirydate" firstDayOfWeek="1" dateFormat="dd/mm/yy" (onSelect)="DoDateValidCheck(); DoDateCheck();" [showIcon]="true" inputId="venueclosingstartdate"></p-datepicker>
                  <div style="clear:both;"></div>
                  @if (!LinkExpiryValid) {
                    <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>The selected Expiry Date must be in the future.</div>
                  }
                </div>
              }
              <div class="col-12">
                <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
                  <span class="pi pi-pencil" style="margin-right:8px;"></span>
                Save Changes</button>
                &nbsp;
                <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                  <span class="pi pi-times" style="margin-right:8px;"></span>
                Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }